import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Nav, Navbar, Button, Modal } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';

import useInitCMSData from '../hooks/useInitCMSData';
import ToggleTheme from '../component/ToggleTheme';
import LanguageToggle from '../component/LanguageToggle';
import { FARMER_LOGIN_URL } from '../config/Constant';
import { getActiveLang, routePathname, withLang } from '../utils/language';

import farmerLogoLight from '../img/KOUPLogoLight.svg';
import farmerLogoDark from '../img/KOUPLogoDark.svg';

const renderLangText = (data, lang) => lang === 'ori' ? data?.title_ori : data?.title_en;
const renderLangDesc = (data, lang) => lang === 'ori' ? data?.description_ori : data?.description_en;

const ContactModal = ({ show, handleClose, helpline, email, lang }) => (
  <Modal size="md" centered show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>{lang === 'ori' ? 'ଆମ ସହିତ ସଂଯୋଗ କରନ୍ତୁ' : 'Connect with us'}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className='contact_details'>
        <h6>{renderLangText(helpline, lang)}</h6>
        <a href={`tel:${renderLangDesc(helpline, lang)}`} className='anchertag'>{renderLangDesc(helpline, lang)}</a>

        <h6 className='mt-4'>{renderLangText(email, lang)}</h6>
        <a href={`mailto:${renderLangDesc(email, lang)}`} className='anchertag'>{renderLangDesc(email, lang)}</a>
      </div>
    </Modal.Body>
  </Modal>
);

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('');
  const [showModal, setShowModal] = useState(false);

  const { CMSData, LanguageListing } = useInitCMSData();
  const selectedLanguage = getActiveLang();
  const pagePath = routePathname(location.pathname);

  const {
    welcome = {},
    logo = {},
    dark_logo = {},
    helpline = {},
    email = {},
    gov = {},
    gov1 = {},
    gov2 = {}
  } = CMSData || {};

  const scrollToSection = (id) => {
    document.querySelector('.navbar-collapse')?.classList.remove('show');
    if (pagePath !== '/') navigate(withLang('/'), { state: { targetSection: id } });
    else document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setActiveTab(id);
  };

  const scrollToTop = () => {
    document.querySelector('.navbar-collapse')?.classList.remove('show');
    navigate(withLang('/'));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  useEffect(() => {
    if (location.state?.targetSection) {
      const section = document.getElementById(location.state.targetSection);
      if (section) section.scrollIntoView({ behavior: 'smooth' });
      setActiveTab(location.state.targetSection);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  const navItems = [
    { label: 'Home', label_ori: 'ହୋମ୍', onClick: scrollToTop, condition: pagePath === '/' },
    { label: 'About Us', label_ori: 'ଆମ ବିଷୟରେ', onClick: () => scrollToSection('aboutSection'), condition: activeTab === 'aboutSection' },
    { label: 'FAQs', label_ori: 'ବାରମ୍ବାର ପଚରା ଯାଇଥିବା ପ୍ରଶ୍ନ', path: '/faq' },
    { label: 'How to Use', label_ori: 'କିପରି ବ୍ୟବହାର କରିବା', onClick: () => scrollToSection('HowTouse'), condition: activeTab === 'HowTouse' },
    { label: 'Contact Us', label_ori: 'ଆମ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ', onClick: () => setShowModal(true) }
  ];

  return (
    <>
      <section className='headerTop' id='homeSection'>
        <div className='topMenu'>
          <Container>
            <Row>
              <div className='d-flex justify-content-between mobileHeader'>
                <ul className='left d-flex justify-content-start'>
                  <li dangerouslySetInnerHTML={{ __html: selectedLanguage === 'ori' ? welcome.title_ori : welcome.title_en }} />
                </ul>
                <div className='d-flex justify-content-end topbar-end'>
                  <ul className='right'>
                    {[helpline, email].map((item, idx) => (
                      <li key={idx} className='d-flex align-items-center'>
                        {item?.logo && <img src={item.logo} alt='' />}
                        <span className='ms-1'>{renderLangText(item, selectedLanguage)}</span>
                        <strong className='ms-1'>
                          <a
                            href={idx === 0 ? `tel:${renderLangDesc(item, selectedLanguage)}` : `mailto:${renderLangDesc(item, selectedLanguage)}`}
                            className='anchertag'
                          >
                            {renderLangDesc(item, selectedLanguage)}
                          </a>
                        </strong>
                      </li>
                    ))}
                    <li><ToggleTheme /></li>
                    <li><LanguageToggle LanguageListing={LanguageListing} /></li>
                  </ul>
                </div>
              </div>
            </Row>
          </Container>
        </div>

        <Container>
          <Row className='align-items-center mt-2 mb-2'>
            <Col lg={6}><Link to={withLang('/')} className='logo d-flex align-items-center text-decoration-none' onClick={scrollToTop}>
                <div className='logo-images'>                  <img src={logo.logo || farmerLogoLight} className='lightLogo' alt='Logo' />
                  <img src={dark_logo.logo || farmerLogoDark} className='darKLogo' alt='Dark Logo' />

                </div>
                <div className="header-content ms-3">
                  <p className="portal-title mb-0">{selectedLanguage === "en" ? "Krushak Odisha Unified Portal" : "କୃଷକ ଓଡିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍‌"}</p>
                  
                  <p className='portal-subtitle'>{selectedLanguage === "en" ? "An Initiative of Odisha Government." : "ଓଡ଼ିଶା ସରକାରଙ୍କ ପକ୍ଷରୁ ଏକ ପ୍ରୟାସ"}</p>
              </div>
            </Link></Col>

            <Col lg={6} className='contactInfo_home text-center'>
              <ul>
                {[gov, gov1, gov2].map((govData, idx) => (
                  <li key={idx}>
                    {govData.logo && <img src={govData.logo} alt='gov' className='mb-2' />}
                    <span>
                      <strong>{renderLangDesc(govData, selectedLanguage)}</strong>
                      <small>{renderLangText(govData, selectedLanguage)}</small>
                    </span>
                  </li>
                ))}
              </ul>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <div className='newNavbar'>
                <Navbar expand='lg' className='greenColor'>
                  <Navbar.Toggle aria-controls='basic-navbar-nav' />
                  <Navbar.Collapse id='basic-navbar-nav'>
                    <Nav className='me-auto'>
                      {navItems.map((item, idx) => (
                        item.path ? (
                          <Nav.Link
                            key={idx}
                            as={Link}
                            to={withLang(item.path)}
                            onClick={() => document.querySelector('.navbar-collapse')?.classList.remove('show')}
                            className={pagePath === item.path ? 'active' : ''}
                          >
                            {selectedLanguage === 'ori' ? item.label_ori : item.label}
                          </Nav.Link>
                        ) : (
                          <Nav.Link
                            key={idx}
                            onClick={item.onClick}
                            className={item.condition ? 'active' : ''}
                          >
                            {selectedLanguage === 'ori' ? item.label_ori : item.label}
                          </Nav.Link>
                        )
                      ))}
                      <Nav.Link>
                        <Button variant='outline-secondary' onClick={() => window.open(FARMER_LOGIN_URL, '_blank')}>{selectedLanguage === 'ori' ? 'କୃଷକ ଲଗଇନ୍' : 'Farmer Login'}</Button>
                      </Nav.Link>
                    </Nav>
                  </Navbar.Collapse>
                </Navbar>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <ContactModal show={showModal} handleClose={() => setShowModal(false)} helpline={helpline} email={email} lang={selectedLanguage} />
    </>
  );
}

export default Header;
